import React, { } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import 'react-toastify/dist/ReactToastify.css';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import TextFieldDate from '../../UI/TextFieldDate';
import dayjs from 'dayjs';

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',

    },
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(1),
    },
    title: {
        flex: '1 1 100%',
        paddingTop: '20px;'
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    },
    closeIcon: {
        marginTop: '20px',
        marginBottom: '20px',
        cursor: 'pointer'
    },
    loading: {
        marginRight: '10px',
        marginLeft: '10px'
    }
}));

export default function ObservacaoAlunoFormV2({ observacaoAluno, setObservacaoAluno, clickSubmit, isLoadingSave }) {
    const classes = useStyles();

    const handleChange = (event) => {
        setObservacaoAluno({
            ...observacaoAluno,
            [event.target.name]: event.target.value
        })
    }

    const handleDataChange = (data) => {


        setObservacaoAluno({
            ...observacaoAluno,
            data: dayjs(data)
        })
    }




    return (
        <div>
            <Grid container spacing={3}>
                <Grid size={12}>
                    <Container className={classes.paper} component={Paper} maxWidth="sm">
                        <CloseIcon
                            onClick={() => setObservacaoAluno(null)}
                            className={classes.closeIcon}
                            fontSize='small'
                        />
                        <form onSubmit={clickSubmit}>
                            <TextFieldDate
                                fullWidth
                                required
                                disableToolbar
                                label="Data"
                                value={observacaoAluno && observacaoAluno.data ? observacaoAluno.data : null}
                                onChange={handleDataChange}

                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                size='small'
                                multiline
                                rows="4"
                                fullWidth
                                label="Conteúdo"
                                name="conteudo"
                                onChange={handleChange}
                                value={observacaoAluno && observacaoAluno.conteudo ? observacaoAluno.conteudo : ''}
                                slotProps={{
                                    htmlInput: { maxLength: 2000 }
                                }}
                            />
                            <Button
                                type="submit"
                                disabled={isLoadingSave}
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                {isLoadingSave && <CircularProgress className={classes.loading} color="primary" size={20} />}
                                Salvar
                            </Button>
                        </form>
                    </Container>
                </Grid>
            </Grid>
        </div>
    );
}